<template>
	<Loader v-if="loading" />
	<div v-else class="content">

		<table>
			<thead>
				<tr>
					<th>Order</th>
					<th>Type</th>
					<th>Status</th>
					<th>Value</th>
					<th>Outstanding<sup>1</sup></th>
					<th>Ready for capture<sup>2</sup></th>
					<th>Order date</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="order in records">
					<td>
						<OrderLink :id="order.id" />
					</td>
					<td>
						{{ order.order_type.name }}
					</td>
					<td>
						{{ order.state.as_text }}
					</td>
					<td>
						<Format
							type="money"
							:currency="order.order_total.currency"
							:value="order.order_total.price" />
					</td>
					<td>
						<Format
							v-if="order.outstanding_balance.cached"
							type="money"
							:currency="order.outstanding_balance.cached.currency"
							:value="order.outstanding_balance.cached.price" />
						<template v-else>N/A</template>
					</td>
					<td>
						<Format
							v-if="order.ready_for_capture"
							type="money"
							:currency="order.order_total.currency"
							:value="order.ready_for_capture.amount" />
						<template v-else>N/A</template>
					</td>
					<td>
						{{ order.order_date.date_time }}
					</td>
					<td class="text-right">
            <DownloadInvoice :order-id="order.id" :classes="['gray', 'small']"/>
					</td>
				</tr>
			</tbody>
		</table>
		<div class="bg-light-grey margin-top small-padding">
			Showing {{ recordLength }} of {{ totalRecords }} order(s)
		</div>
		<div v-if="currentPage !== lastPage">
			<button class="gray full-width very-small-margin-top" v-on:click="load(currentPage + 1)">
				+ Load more ...
			</button>
		</div>

		<div class="note margin-top">
			1) Cached number. It may not be entirely up-to-date.
			If in doubt, please open the order to see factual number.
		</div>
		<div class="note margin-top">
			2) Number is only calculated if the (cached) outstanding balance
			is over 0
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import DownloadInvoice from '../DownloadInvoice.vue'

export default {
  components: { DownloadInvoice },
  props: [
    'id'
  ],
  data: () => ({
    loading: false,
    records: [],
    currentPage: 1,
    lastPage: 1,
    totalRecords: 0,
    recordLength: 0,
    customer: {}
  }),
  methods: {
    load (page) {
      if (undefined === page) {
        page = 1
      }
      Vue.$api.get('/customer/' + this.id + '/orders?v=2&page=' + page, {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.parse(data, page)
      })
    },
    parse (data, page) {
      this.totalRecords = data.orders.total
      this.currentPage = data.orders.currentPage
      this.lastPage = data.orders.lastPage
      if (page === 1) {
        this.records = data.orders.items
      } else {
        const record = data.orders.items
        for (var i in record) {
          const key = parseInt(this.recordLength) + parseInt(i)
          Vue.set(this.records, key, record[i])
        }
      }
      this.recordLength = this.records.length
      this.customer = data.customer
    }
  },
  created () {
    this.load()
  }
}
</script>
